<template>
  <li class="content-box reporting__click__rank-list-item" v-if="item.coords">
    <strong>
      <span class="rank">{{ index + 1 | rank }}.</span>
      <span class="value"> {{ item.value | thousand }} {{ valueUnit }}</span>
    </strong>
    <div class="rank-list-item__element-info" @click="$emit('onThumbnailClick', item)">
      <div class="rank-list-item__element-img">
        <div class="element-img--wrap">
          <crop-image :url="imageData.url"
            :imageWidth="imageData.width"
            :imageHeight="imageData.height"
            :width="item.coords.width"
            :height="item.coords.height"
            :offset="{ x: item.coords.left, y: item.coords.top }"/>
        </div>
        <div class="hover_mark icon--crosshair-mark"></div>
      </div>
      <div class="rank-list-item__element-detail">
        <ul>
          <!-- todo: i18n check -->
          <li>x position : {{ item.coords.left | round | thousand }}px</li>
          <li>y position : {{ item.coords.top | round | thousand }}px</li>
          <li>size : {{ item.coords.width | round | thousand }} x
            {{ item.coords.height | round | thousand }} (px)</li>
        </ul>
      </div>
    </div>
    <div class="rank-list-item__element-analysis clearfix" >
      <ul v-if="!isZoom">
        <li v-if="isDesktopDevice || !bNewMobileCheck">
          <ui-icon-tooltip>
            <span v-html="$t('common.reportIndicator.clickRate.tooltip')"></span>
          </ui-icon-tooltip>
          <p>
            <span class="title">{{ $t('common.reportIndicator.clickRate.label') }}</span>
            <span class="value">{{ item.coords.clickRate | fixed(1) }} %</span>
          </p>
        </li>
        <li v-else>
          <ui-icon-tooltip>
            <span v-html="$t('common.reportIndicator.tapRate.tooltip')"></span>
          </ui-icon-tooltip>
          <p>
            <span class="title">{{ $t('common.reportIndicator.tapRate.label') }}</span>
            <span class="value">{{ item.coords.tapRate | fixed(1) }} %</span>
          </p>
        </li>
        <li v-if="isDesktopDevice || !bNewMobileCheck">
          <ui-icon-tooltip>
            <span v-html="$t('common.reportIndicator.clickPvRate.tooltip')"></span>
          </ui-icon-tooltip>
          <p>
            <span class="title">{{ $t('common.reportIndicator.clickPvRate.label') }}</span>
            <span class="value">{{ item.coords.clickPvRate | fixed(1) }} %</span>
          </p>
        </li>
        <li v-else>
          <ui-icon-tooltip>
            <span v-html="$t('common.reportIndicator.tapPvRate.tooltip')"></span>
          </ui-icon-tooltip>
          <p>
            <span class="title">{{ $t('common.reportIndicator.tapPvRate.label') }}</span>
            <span class="value">{{ item.coords.tapPvRate | fixed(1) }} %</span>
          </p>
        </li>
        <li v-if="item.coords.hoverClickRate && this.isDesktopDevice">
          <ui-icon-tooltip>
            <span v-html="$t('common.reportIndicator.hoverToClick.tooltip')"></span>
          </ui-icon-tooltip>
          <p class="analysis">
            <span class="title">{{ $t('common.reportIndicator.hoverToClick.label') }}</span>
            <span class="value">{{ item.coords.hoverClickRate | fixed(1) }} %</span>
          </p>
        </li>
      </ul>
      <ul v-else>
        <li>
          <ui-icon-tooltip>
            <span v-html="$t('common.reportIndicator.zoominRate.tooltip')"></span>
          </ui-icon-tooltip>
          <p>
            <span class="title">{{ $t('common.reportIndicator.zoominRate.label') }}</span>
            <span class="value">{{ item.coords.zoominRate | fixed(1) }} %</span>
          </p>
        </li>
      </ul>
      <ul v-if="!isZoom">
        <li>
          <ui-icon-tooltip arrowCenter><span v-html="$t('common.reportIndicator.scrollToClick.tooltip')"></span></ui-icon-tooltip>
          <p>
            <span class="title" v-if="isDesktopDevice || !bNewMobileCheck">{{ $t('common.reportIndicator.scrollToClick.label') }}</span>
            <span class="title" v-else>{{ $t('common.reportIndicator.scrollToTap.label') }}</span>
            <span class="value">{{ item.coords.scrollPvToPv | scrollPvToPv }}%</span>
          </p>
        </li>
        <li v-if="!isDesktopDevice && bNewMobileCheck">
          <ui-icon-tooltip arrowCenter><span v-html="$t('common.reportIndicator.dblTapRate.tooltip')"></span></ui-icon-tooltip>
          <p>
            <span class="title click-time" v-html="$t('common.reportIndicator.dblTapRate.label')"></span>
            <span class="value">{{ item.coords.doubleTapRate | fixed(1) }} %</span>
          </p>
        </li>
        <li v-if="item.coords.hoverClickTime && isDesktopDevice && !isAMP">
          <ui-icon-tooltip arrowCenter><span v-html="$t('common.reportIndicator.hoverClickTime.tooltip')"></span></ui-icon-tooltip>
          <p>
            <span class="title click-time" v-html="$t('common.reportIndicator.hoverClickTime.label')"></span>
            <span class="value">{{ item.coords.hoverClickTime | fixed(1) }} sec</span>
          </p>
        </li>
      </ul>
      <ul v-else>
        <li>
          <ui-icon-tooltip>
            <span v-html="$t('common.reportIndicator.zoomoutRate.tooltip')"></span>
          </ui-icon-tooltip>
          <p>
            <span class="title">{{ $t('common.reportIndicator.zoomoutRate.label') }}</span>
            <span class="value">{{ item.coords.zoomoutRate | fixed(1) }} %</span>
          </p>
        </li>
      </ul>
    </div>
    <div class="rank-list-item__element-chart" v-if="this.item.chartData.length !== 1">
      <app-chart chartType="line"
        :chartOptions="chartOptions"
        :height="180"/>
    </div>
  </li>
</template>

<script>
import { parse, format } from 'date-fns'
import { thousand } from '@/libs/utils'
import { getTooltipHtml } from '@/libs/chart-helper'
import AppChart from '@/components/chart'
import CropImage from '@/components/ui/CropImage'
import UiIconTooltip from '@/components/ui/UiIconTooltip'
import { NEW_MOBILE_HEATMAP_STARTDATE } from '@/libs/constants'
import { mapState } from 'vuex'

export default {
  name: 'RankItem',
  components: {
    AppChart,
    CropImage,
    UiIconTooltip
  },
  props: [
    'type',
    'index',
    'item',
    'imageData',
    'isDesktopDevice',
    'isAMP',
    'reportData'
  ],
  computed: {
    ...mapState([
      'reportPeriod'
    ]),
    isZoom () {
      return ['zoomin', 'zoomout'].includes(this.type)
    },
    bNewMobileCheck () {
      let bNewMobile = true
      if (this.reportPeriod.start < NEW_MOBILE_HEATMAP_STARTDATE || this.isAMP) {
        bNewMobile = false
      }

      return bNewMobile
    },
    valueUnit () {
      switch (this.type) {
        case 'click':
          return this.$t('common.unit.clicks')
        case 'tap':
          return this.$t('common.unit.tap')
        case 'zoomin':
          return this.$t('common.unit.zoomin')
        case 'zoomout':
          return this.$t('common.unit.zoomout')
        case 'pv':
          return 'PV'
        case 'hover':
          return this.$t('common.reportIndicator.hovers.label')
        default:
          throw new Error(`invalid type: ${this.type}`)
      }
    },
    chartOptions () {
      const valueUnit = this.valueUnit

      return {
        meta: {
          isDailyChart: true
        },
        xAxis: {
          splitNumber: 6
        },
        yAxis: {
          splitNumber: 2
        },
        series: [
          {
            name: this.valueUnit,
            type: 'line',
            smooth: true,
            data: this.item.chartData
          }
        ],
        tooltip: {
          formatter (params) {
            const param = params[0]
            const title = format(parse(param.data[0]), 'MM-DD')
            const content = [
              [`${param.marker}${valueUnit} :`, thousand(param.data[1])]
            ]
            return getTooltipHtml(content, title)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.reporting__click__rank-list-item {
  margin-top: 30px;

  strong {
    font-size: 15px;
    .rank {
      color: #2f2f2f;
    }
    .value {
      color: $brandColor;
    }
  }

  .rank-list-item__element-info {
    margin-top: 13px;
    display: flex;
    justify-content: space-between;
    height: 75px;
    border-radius: 6px;
    border: solid 1px #d7d7d7;
    background-color: #f4f4f4;
    color: #666666;
    cursor: pointer;

    .rank-list-item__element-img {
      position: relative;
      width: calc(100% - 145px);

      .element-img--wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: transparent;
        }
      }
    }

    .rank-list-item__element-detail {
      position: relative;
      width: 145px;

      ul {
        width: 100%;
        position: absolute;
        top: 50%;
        right: 50%;
        transform: translate(50%, -50%);
        font-size: 12px;
        line-height: 1.5;
      }
    }

    .hover_mark {
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate(50%, -50%);
      display: none;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.7);
      color: #fff;
      transition: all 0.1s ease-in;

      .hover_mark {
        display: block;
      }

      .element-img--wrap::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.7);
        transition: all 0.1s ease-in;
      }
    }
  }

  .rank-list-item__element-analysis{
    margin-top: 13px;

    ul{
      float: left;
      width: 50%;

      li {
        margin-top: 12px;
      }

      p {
        display: inline-block;
        vertical-align: top;
        font-size: 13px;
        width: calc(100% - 20px); /* 20px = icon's width */
        min-width: 123px;
        max-width: 175px;

        .title {
          margin-left: 4px;
          color: #666666;

          &.click-time {
            /deep/ .icon {
              position: relative;
              top: 1px;
              margin: 0 2px;
            }
          }
        }

        .value {
          color: #2f2f2f;
          float: right;
        }
      }
    }
  }

  .rank-list-item__element-chart {
    margin-top: 18px;
  }
}
@media screen and (min-width: 1790px) {
  li.content-box.reporting__click__rank-list-item {
    display: inline-block;
    width: calc(50% - 15px);

    &:nth-child(2n-1) {
      margin-right: 30px;
    }
  }
}
</style>
